import React, { Fragment, useEffect, useState } from "react";
// import Routes from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
// import "../node_modules/toastr/build/toastr.css";
// import "~slick-carousel/slick/slick.css";
// import "../node_modules/slick-carousel/";
// import "../node_modules/";
// import "~slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Ably from "ably";
import { AblyProvider, ChannelProvider } from "ably/react";
import { MeetingAppProvider } from "./components/azure-video/MeetingAppContextDef";
import { VideoCallScreen } from "./VideoCallScreen";

// Import all CSS files
import './App.css';
import './index.css';
import './assets/styles/common.css';
import './components/analytics-landing-page/analytics-landing.css';
import './components/analytics-screen/styles.css';
import './components/azure-video/styles.css';
import './components/calculator/style.css';
import './components/filter/filter.css';
import './components/gallery/gallery.css';
import './components/geoTracking/styles.css';
import './components/header/header.css';
import './components/landing-page/landing.css';
import './components/loader/loader.css';
import './components/map-screen/map.css';
import './components/path-box/styles.css';
import './components/pdf/pdf.css';
import './components/popup-details/popupDetails.css';
import './components/popup-valuation-details/popupDetails.css';
import './components/ppi-barchart/ppi-chart.css';
import './components/ppi-filter/ppi-filter.css';
import './components/property-report-pdf/index.css';
import './components/rapidWeb/VideoCall/styles.css';
import './components/report/styles.css';
import './components/reports-data/styles.css';
import './components/servey-report/styles.css';
import './components/side-bar/side-bar.css';
import './components/users-page/styles.css';
import './components/valuation-filter/Autocomplete.css';
import './components/valuation-filter/valuation-filter.css';
import './components/vendor/styles.css';
import './components/videoMemo/videoMemo.css';
import './components/voiceMemo/voiceMemo.css';
import './containers/advareportTAT/styles.css';
import './containers/analytics/analytics.css';
import './containers/automated-valuation/valuation.css';
import './containers/dash-board/dashBoard.css';
import './containers/history-layout/history.css';
import './containers/login/logIn.css';
import './containers/property-price-index/ppi.css';
import './containers/rapidWeb/styles.css';
import './containers/reports-analytics/styles.css';
import './containers/users/styles.css';
import './containers/video-call/vide.css';
import './public-screen/not-found/not-found.css';
const routes = {
  home: '/home',
  videocall: '/videocall',
}

function getRouteFromPath(pathname) {
  return pathname === routes.videocall ? 'videocall' : 'home'
}

function Header() {
  return (
    <header className="app-header">
      <h1>DEMO</h1>
    </header>
  )
}

// Room IDs set up for the team (one per property). The backend has the authoritative list.
const ROOM_IDS = Array.from({ length: 10 }, (_, i) => String(25 + i).padStart(8, '0'))

// "25" or "0000025" -> "00000025": numeric IDs are 8 digits, so pad short ones.
const normalizeRoomId = (value) => {
  const v = value.trim()
  return /^\d{1,8}$/.test(v) ? v.padStart(8, '0') : v
}

function HomeScreen({ onEnterRoom, apiError }) {
  const [roomId, setRoomId] = useState('')
  const [error, setError] = useState('')
  const [showGallery, setShowGallery] = useState(false)
  const [galleryImages, setGalleryImages] = useState([])
  const [isLoadingGallery, setIsLoadingGallery] = useState(false)
  const [previewImage, setPreviewImage] = useState(null) 

  function handleSubmit(event) {
    event.preventDefault()
    // Remove frontend validation - let backend handle it
    if (roomId.trim() === '') {
      setError('Please enter a room ID')
      return
    }
    setError('')
    const id = normalizeRoomId(roomId)
    setRoomId(id)
    onEnterRoom(id)
  }

  async function handleEnterGallery() {
    if (roomId.trim() === '') {
      setError('Please enter a room ID to view gallery')
      return
    }
    
    const id = normalizeRoomId(roomId)
    setRoomId(id)
    setIsLoadingGallery(true)
    setShowGallery(true)
    setError('') 
    
    try {
      // Call the get images API with room ID
      const response = await fetch(`https://dev.api.customer-connect.satsure.co/api/v1/public/get-image?room_id=${encodeURIComponent(id)}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      })

      const result = await response.json()

      if (response.ok && result.status) {
        // Assuming the API returns an array of image objects
        setGalleryImages(result.data || [])
        toast.success('Gallery loaded successfully!', {
          position: toast.POSITION.BOTTOM_RIGHT,
        })
      } else {
        // Backend returned error - show inline
        setError(result.message || 'Failed to load gallery')
        setGalleryImages([])
      }
    } catch (error) {
      console.error('Gallery error:', error)
      setError('Failed to connect. Please try again.')
      setGalleryImages([])
    } finally {
      setIsLoadingGallery(false)
    }
  }

  return (
    <main className="screen screen-centered">
      <form className="room-card" onSubmit={handleSubmit}>
        <label htmlFor="room-id">Enter The Room ID</label>
        <input
          id="room-id"
          name="roomId"
          type="text"
          placeholder="Room ID (e.g. 00000025)"
          list="room-id-options"
          autoComplete="off"
          value={roomId}
          onChange={(event) => {
            setRoomId(event.target.value)
            if (error) setError('')
          }}
          pattern="[A-Za-z0-9]{1,20}"
          required
          title="Please enter a code." 
        />
        <datalist id="room-id-options">
          {ROOM_IDS.map((id) => <option key={id} value={id} />)}
        </datalist>
        {error && <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>{error}</div>}
        <button style={{backgroundColor:'#2A5DA8'}} type="submit">Enter The Room</button>
        {apiError && <div style={{ color: 'red', marginTop: '10px', fontSize: '14px', textAlign: 'center' }}>{apiError}</div>}
        <button 
          style={{
            backgroundColor:'#28a745',
            marginTop: '10px'
          }} 
          type="button"
          onClick={handleEnterGallery}
          disabled={isLoadingGallery}
        >
          {isLoadingGallery ? 'Loading...' : 'Enter The Gallery'}
        </button>
      </form>

      {/* Gallery Section */}
      {showGallery && (
        <div style={{
          marginTop: '30px',
          width: '90%',
          maxWidth: '1200px',
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px'
          }}>
            <h3 style={{ margin: 0 }}>Image Gallery · Room {roomId} ({galleryImages.length})</h3>
            <button
              onClick={() => setShowGallery(false)}
              style={{
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '8px 16px',
                cursor: 'pointer'
              }}
            >
              Close
            </button>
          </div>

          <div style={{
            maxHeight: '300px',
            overflowX: 'auto',
            overflowY: 'hidden',
            border: '1px solid #ddd',
            borderRadius: '4px',
            padding: '15px'
          }}>
            {isLoadingGallery ? (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <p>Loading images...</p>
              </div>
            ) : galleryImages.length > 0 ? (
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '15px',
                minHeight: '250px'
              }}>
                {galleryImages.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      position: 'relative',
                      minWidth: '250px',
                      width: '250px',
                      height: '250px',
                      backgroundColor: '#f0f0f0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      flexShrink: 0
                    }}
                  >
                    <img
                      src={image.signed_url || image.url || image.image_url || image}
                      alt={`Gallery ${index + 1}`}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                      onError={(e) => {
                        e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect fill="%23ddd" width="200" height="200"/%3E%3Ctext fill="%23999" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3ENo Image%3C/text%3E%3C/svg%3E'
                      }}
                    />
                    {/* Eye Icon Overlay */}
                    <div
                      onClick={() => setPreviewImage(image.signed_url || image.url || image.image_url || image)}
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        width: '40px',
                        height: '40px',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        transition: 'all 0.3s',
                        zIndex: 10
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(42, 93, 168, 0.9)';
                        e.currentTarget.style.transform = 'scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                      </svg>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                <p>No images found in the gallery</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Image Preview Modal */}
      {previewImage && (
        <div
          onClick={() => setPreviewImage(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '20px'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%',
              backgroundColor: 'white',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setPreviewImage(null)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                width: '40px',
                height: '40px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#333',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                zIndex: 10
              }}
            >
              ×
            </button>
            
            {/* Preview Image */}
            <img
              src={previewImage}
              alt="Preview"
              style={{
                maxWidth: '100%',
                maxHeight: '90vh',
                display: 'block'
              }}
            />
          </div>
        </div>
      )}
    </main>
  )
}

const App = () => {
  const client = new Ably.Realtime({
    key: "MnLrtg.SgE_JQ:gdNMGCjfgbEQULQsra39cLc1E2YxjfWi_OH4YisD5is",
  });
  const [route, setRoute] = useState(() => getRouteFromPath(window.location.pathname))
  const [roomId, setRoomId] = useState('')
  const [apiresponse, setApiResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(''); // Add state for API errors
  
  useEffect(() => {
    if (!Object.values(routes).includes(window.location.pathname)) {
      window.history.replaceState({}, '', routes.home)
    }

    function handlePopState() {
      setRoute(getRouteFromPath(window.location.pathname))
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  async function navigateToVideoCall(nextRoomId) {
    setIsLoading(true);
    setApiError(''); // Clear previous errors
    try {
      const response = await fetch(`https://dev.api.customer-connect.satsure.co/api/v1/public/video-call?room_id=${nextRoomId}`);
      const data = await response.json();
      
      // Check if backend returned error (status: false)
      if (!data.status) {
        // Backend validation failed - set error to display below button
        setApiError(data.message || 'Invalid room ID');
        setIsLoading(false);
        return;
      }
      
      // Success - proceed to video call
      setRoomId(nextRoomId);
      setApiResponse(data);
      setApiError(''); // Clear any errors
      window.history.pushState({}, '', routes.videocall);
      setRoute('videocall');
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setApiError('Failed to connect. Please try again.');
      setIsLoading(false);
    }
  }


  return (
    <Fragment>
    <MeetingAppProvider>
    <AblyProvider client={client}>
      <ChannelProvider channelName="get-started">
      <div className="app-shell">
      <Header />
      {route === 'videocall' ? (
        <VideoCallScreen roomId={roomId} apiresponse={apiresponse} />
      ) : (
        <HomeScreen onEnterRoom={navigateToVideoCall} apiError={apiError} />
      )}
    </div>    
      </ChannelProvider>
    </AblyProvider>
    </MeetingAppProvider>
    <ToastContainer position="bottom-right" autoClose={5000} />
  </Fragment>
  
  );
};

export default App;
